var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6C3D6",
    d: "M32 8c6.187 0 11.2 4.988 11.2 11.147 0 6.145-5.013 11.147-11.2 11.147-6.189 0-11.2-5.002-11.2-11.147C20.8 12.988 25.811 8 32 8M32 33.48c11.487 0 20.8 7.129 20.8 15.924s-41.6 8.795-41.6 0S20.513 33.479 32 33.479"
  })));
};
export default SvgIconUser;